import React from 'react';
import {Link} from 'react-router-dom';
import Logo from'./img/logo.png';

export default ()=> (
	<Link to="/" style={{display:"flex", alignItems: 'center'}}>
	<img src={Logo} style={{height:"3rem", marginRight:"1rem"}}/> 
	<div>
	<h1> Gran Canaria Ecol&oacute;gica</h1>
	<h2>Si comes, te interesa.</h2>
	</div>
	</Link>
	)


// WEBPACK FOOTER //
// ./src/Logo.js